/* tslint:disable */
/* eslint-disable */
/**
 * DIV.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface YearsResponse
 */
export interface YearsResponse {
    /**
     * 
     * @type {Array<number>}
     * @memberof YearsResponse
     */
    availableYears: Array<number> | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof YearsResponse
     */
    selectedYears: Array<number> | null;
}

/**
 * Check if a given object implements the YearsResponse interface.
 */
export function instanceOfYearsResponse(value: object): value is YearsResponse {
    if (!('availableYears' in value) || value['availableYears'] === undefined) return false;
    if (!('selectedYears' in value) || value['selectedYears'] === undefined) return false;
    return true;
}

export function YearsResponseFromJSON(json: any): YearsResponse {
    return YearsResponseFromJSONTyped(json, false);
}

export function YearsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): YearsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'availableYears': json['availableYears'] == null ? null : json['availableYears'],
        'selectedYears': json['selectedYears'] == null ? null : json['selectedYears'],
    };
}

export function YearsResponseToJSON(json: any): YearsResponse {
    return YearsResponseToJSONTyped(json, false);
}

export function YearsResponseToJSONTyped(value?: YearsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'availableYears': value['availableYears'],
        'selectedYears': value['selectedYears'],
    };
}

